export default __webpack_public_path__ + "static/media/apple_button.cdabdcfa.png";